var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FlexGrid, Skeleton, Styler, TypographyBody } from '@honeycomb/ui-core';
import React from 'react';
import { PRICE_CALENDAR_COLUMN_SPACING, PRICE_CALENDAR_ROW_SPACING } from '../../../utils';
export function HotelPriceCalendarSkeleton(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Styler, Object.assign({ w: 330, py: 4, px: 2 }, props),
        React.createElement(TypographyBody, { w: 150, mb: 3 },
            React.createElement(Skeleton, { variant: "text" })),
        React.createElement(Styler, { py: PRICE_CALENDAR_ROW_SPACING, px: PRICE_CALENDAR_COLUMN_SPACING },
            React.createElement(FlexGrid, { container: true, columns: 7, rowSpacing: PRICE_CALENDAR_ROW_SPACING, columnSpacing: PRICE_CALENDAR_COLUMN_SPACING },
                [...Array(7).keys()].map((cell) => (React.createElement(FlexGrid, { xs: 1, key: cell },
                    React.createElement(Skeleton, { w: "100%", h: 36, br: 5 })))),
                [...Array(2).keys()].map((cell) => (React.createElement(FlexGrid, { xs: 1, key: cell }))),
                [...Array(31).keys()].map((cell) => (React.createElement(FlexGrid, { xs: 1, key: cell },
                    React.createElement(Skeleton, { w: "100%", h: 55, br: 5 }))))))));
}
